import {
  FeatureLibraryItem,
  FeaturesLibrarySection,
} from '@/types/cxp-solution-page'

/**
 * Lấy label của feature dựa theo locale
 */
export function getFeatureLabel(
  feature: FeatureLibraryItem,
  locale: string = 'vi'
): string {
  return feature.label_vi
}

/**
 * Tìm kiếm feature trong library bằng ID
 */
export function getFeatureById(
  featuresLibrary: FeaturesLibrarySection | undefined,
  id: string
): FeatureLibraryItem | null {
  if (!featuresLibrary || !featuresLibrary.features) {
    return null
  }

  return (
    featuresLibrary.features.find(
      (feature) => feature.id === id && feature.is_active !== false
    ) || null
  )
}

/**
 * Tạo map các feature để lookup nhanh hơn
 */
export function createFeatureMap(
  featuresLibrary: FeaturesLibrarySection | undefined
): Map<string, FeatureLibraryItem> {
  const featureMap = new Map<string, FeatureLibraryItem>()

  if (featuresLibrary && featuresLibrary.features) {
    featuresLibrary.features.forEach((feature) => {
      if (feature.is_active !== false) {
        featureMap.set(feature.id, feature)
      }
    })
  }

  return featureMap
}
